import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import "../../styles/Pages.css";
import "../../styles/MyProfile.css";

function Overview() {
  const { user } = useContext(AuthContext);
  const isAdmin = user?.role === "admin" || user?.role === "superadmin";
  const initials = user?.name
    ? user.name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2)
    : "U";

  const quickLinks = [
    { to: "/profile", label: "👤 My Profile", desc: "View and update your profile" },
    { to: "/events", label: "🎉 Events & Polls", desc: "Browse live polls and events" },
    { to: "/settings", label: "⚙️ Settings", desc: "Account preferences" },
    ...(isAdmin ? [
      { to: "/admin-dashboard", label: "🛡️ Admin Dashboard", desc: "Manage college data", admin: true },
      { to: "/admin/polls", label: "🗳️ Poll Management", desc: "Create & manage polls", admin: true },
    ] : []),
  ];

  return (
    <div className="page-wrapper">
      <Navbar />
      <div className="page-hero">
        <h1>📊 Dashboard</h1>
        <p>Welcome back, {user?.name || "User"}!</p>
      </div>

      <div className="page-content">
        {/* ── Welcome Banner ── */}
        <div className="profile-card-main">
          <div className="profile-avatar-large">{initials}</div>
          <div className="profile-info-block">
            <h2 className="profile-name">{user?.name || "User"}</h2>
            <span className={`profile-role-badge role-${user?.role}`}>
              {user?.role === "superadmin" ? "⭐ Super Admin" :
               user?.role === "admin" ? "🛡️ Admin" : "🎓 User"}
            </span>
            <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.88rem", margin: "0.3rem 0 0" }}>
              {user?.email}
            </p>
          </div>
        </div>

        {/* ── Account Info ── */}
        <div className="info-card">
          <h2>Account Summary</h2>
          <div className="profile-details-grid">
            <div className="profile-detail-item">
              <span className="profile-detail-label">📧 Email</span>
              <span className="profile-detail-value">{user?.email || "—"}</span>
            </div>
            <div className="profile-detail-item">
              <span className="profile-detail-label">🔑 Role</span>
              <span className="profile-detail-value" style={{ textTransform: "capitalize" }}>
                {user?.role || "user"}
              </span>
            </div>
            <div className="profile-detail-item">
              <span className="profile-detail-label">🏛️ Department</span>
              <span className="profile-detail-value">{user?.department || "Not set"}</span>
            </div>
            <div className="profile-detail-item">
              <span className="profile-detail-label">📱 Phone</span>
              <span className="profile-detail-value">{user?.phone || "Not set"}</span>
            </div>
          </div>
        </div>

        {/* ── Quick Actions ── */}
        <div className="info-card">
          <h2>Quick Actions</h2>
          <div className="overview-quick-grid">
            {quickLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`overview-action-card ${link.admin ? "admin-card" : ""}`}
              >
                <span className="oa-label">{link.label}</span>
                <span className="oa-desc">{link.desc}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* ── Announcements ── */}
        <div className="info-card">
          <h2>📢 Announcements</h2>
          <div className="overview-notice">
            <span className="overview-notice-icon">🎉</span>
            <div>
              <strong>Farewell Poll Season!</strong>
              <p style={{ margin: "0.2rem 0 0", color: "#555", fontSize: "0.88rem" }}>
                Annual farewell award polls are live. Head to{" "}
                <Link to="/events" style={{ color: "#2e7d32", fontWeight: 600 }}>
                  Events &amp; Polls
                </Link>{" "}
                to cast your vote!
              </p>
            </div>
          </div>
          {isAdmin && (
            <div className="overview-notice admin-notice" style={{ marginTop: "0.8rem" }}>
              <span className="overview-notice-icon">🛡️</span>
              <div>
                <strong>Admin Access</strong>
                <p style={{ margin: "0.2rem 0 0", color: "#555", fontSize: "0.88rem" }}>
                  You have admin privileges.{" "}
                  <Link to="/admin/polls" style={{ color: "#2e7d32", fontWeight: 600 }}>
                    Manage polls
                  </Link>{" "}
                  or visit the{" "}
                  <Link to="/admin-dashboard" style={{ color: "#2e7d32", fontWeight: 600 }}>
                    Admin Dashboard
                  </Link>.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Overview;